import { useEffect } from 'react'
import { isIOS, isAndroid } from '@docs/common'

const STYLE = `
  body {
    position: absolute;
    width: 375px;
    left: 50%;
    margin-left: -187.5px
  }
  [data-name=navigation] {
    display: none
  }
  [data-name=client-only] > div {
    width: 375px;
    left: auto;
    right: auto;
  }
  [data-name=client-only] > div > div {
    width: 340px;
  }
`

export default function usePcAdaptation() {
  useEffect(() => {
    if (isIOS || isAndroid) return
    const style = document.createElement('style')
    style.innerHTML = STYLE
    document.head.appendChild(style)
  }, [])
}
